<template>
  <div class="regionTreeCom">
    <el-tree
      :data="dataList"
      :props="defaultProps"
      node-key="id"
      highlight-current
      accordion
      :default-expanded-keys="defaultKeys"
      ref="tree"
      style="
        overflow: auto;
        background: #f7f7f7;
        border: 1px solid #e7e7e7;
        border-radius: 6px;
        padding: 20px 0 30px;
        margin-top: 10px;
        height: 80%;
      "
    >
    </el-tree>
    <div class="btnBox">
      <el-button @click="onSubmit" type="primary" style="width: 80%"
        >确 认</el-button
      >
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name",
      },
      dataList: [],
      treeAllData: [],
      defaultKeys: [], //默认打开
    };
  },
  methods: {
    onSubmit() {
      this.$emit("getActiveTree", {
        treeActive: this.$refs.tree.getCurrentKey(),
        treeData: this.$refs.tree.getCurrentNode(),
      });
    },
    getAsseList() {
      let treeAllData = JSON.parse(
        window.sessionStorage.getItem("assetsAllData")
      );
      this.dataList = [treeAllData.区域位置];
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.dataList[0].id);
        this.defaultKeys.push(this.dataList[0].id);
        this.$emit("getActiveTree", {
          treeActive: this.$refs.tree.getCurrentKey(),
          treeData: this.$refs.tree.getCurrentNode(),
        });
      });
    },
  },
  created() {
    this.getAsseList();
  },
};
</script>

<style lang="scss" scoped>
.regionTreeCom {
  width: 93%;
  height: 80%;
  margin: 5% auto;
  ::v-deep
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $themeColor !important;
    color: #fff;
  }
  .btnBox {
    margin-top: 20px;
    @include setFlexCenter;
  }
}
</style>